// extracted by mini-css-extract-plugin
module.exports = {"c1tedkax":"c1tedkax"};